import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * Componente de cabecera de página reutilizable
 * @param {string} title - Título de la página
 * @param {string} subtitle - Subtítulo opcional
 * @param {object} icon - Icono opcional de FontAwesome
 * @param {node} children - Elementos adicionales (botones, breadcrumbs, etc.)
 */
const PageHeader = ({ title, subtitle, icon, children }) => {
  return (
    <header className="modern-page-header">
      <div className="page-header-content">
        <div className="page-header-title-section">
          {icon && (
            <div className="page-header-icon">
              <FontAwesomeIcon icon={icon} />
            </div>
          )}
          <div className="page-header-text">
            <h1 className="page-header-title">{title}</h1>
            {subtitle && <p className="page-header-subtitle">{subtitle}</p>}
          </div>
        </div>
        {children && <div className="page-header-actions">{children}</div>}
      </div>
    </header>
  );
};

export default PageHeader;

